module.exports = __webpack_public_path__ + "img/setting_7.06f8574b.svg";